import { useState } from "react";
import { toast } from "sonner";
import { p, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { BadgeCheck } from "lucide-react";

const vatOk = (v) => {
  let n = (v || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (n.startsWith("IT") && /^\d+$/.test(n.slice(2))) n = n.slice(2);
  if (!n) return false;
  return /^\d+$/.test(n) ? [11, 16].includes(n.length) : n.length >= 5 && n.length <= 20;
};

/** Locali registrati prima dell'obbligo: la partita IVA si chiede una volta sola, al titolare. */
export const ChiediPiva = () => {
  const { vatMissing, user, viewOnly, demoMode, refresh } = useApp();
  const [vat, setVat] = useState("");
  const [busy, setBusy] = useState(false);
  const [fatto, setFatto] = useState(false);

  const apri = vatMissing && !fatto && !viewOnly && !demoMode &&
    ["titolare", "direttore"].includes(user?.role);
  if (!apri) return null;

  const salva = async () => {
    if (!vatOk(vat)) return toast.error("Inserisci una partita IVA valida (11 cifre), il codice fiscale o la P.IVA estera");
    setBusy(true);
    try {
      await p("/tenant/vat", { vat: vat.trim() });
      setFatto(true);
      toast.success("Partita IVA registrata");
      refresh?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open>
      <DialogContent className="max-w-md" data-testid="chiedi-piva">
        <DialogTitle className="flex items-center gap-2 text-lg font-bold">
          <BadgeCheck className="h-5 w-5 text-amber-500" /> Ci manca la tua partita IVA
        </DialogTitle>
        <p className="text-sm text-slate-600">
          La partita IVA identifica in modo univoco il tuo locale: serve una volta sola ed evita account doppi.
          Tutto il resto lo modifichi quando vuoi dalle Impostazioni.
        </p>
        <Input
          className="h-12"
          placeholder="Partita IVA (o codice fiscale)"
          value={vat}
          onChange={(e) => setVat(e.target.value)}
          data-testid="piva-input"
        />
        <Button className="h-12 w-full" disabled={busy} onClick={salva} data-testid="piva-save-btn">
          Salva e continua
        </Button>
        <p className="text-[11px] text-slate-500">
          Hai più sedi con la stessa partita IVA? Scrivici: le colleghiamo noi al tuo profilo.
        </p>
      </DialogContent>
    </Dialog>
  );
};
